(function ($) {
	$(document).ready(function () {
		if ($(".grid").length > 0) {
			var elem = document.querySelector(".grid");
			var msnry = new Masonry(elem, {
				itemSelector: ".grid-item",
				columnWidth: ".grid-item",
				percentPosition: true,
			});

			$(".grid").masonry({
				columnWidth: ".grid-sizer",
				itemSelector: ".grid-item",
				percentPosition: true,
			});
		}
	});
})(jQuery);
